import React, {useEffect, useState} from 'react';
import { getRelationshipData } from '../DropdownDataProviders' ;
import { renderDropdown, renderDropdownReadOnly} from "../DropdownFunctions";
import SpinnerDiv from "../SpinnerDiv";
import PropTypes from "prop-types";

const DropdownRelationshipSelect = (props ) =>
{
    const [ data, setData ] = useState ( { loading: true, items : [] } ) ;

    useEffect(() => {
        getRelationshipData(false).then (response =>
        {
            setData ( { loading: false, items: response }) ;
        })
    }, []);

    return data.loading === true ? <SpinnerDiv/> :
    (
        props.readOnly === 'readonly' ? renderDropdownReadOnly(props, data) : renderDropdown(props, data)
    )
}

export default DropdownRelationshipSelect;

DropdownRelationshipSelect.defaultProps =
{
    defaultClassName: 'form-group'
}

DropdownRelationshipSelect.propTypes = {
    onChange: PropTypes.func.isRequired
};